module.exports = __webpack_public_path__ + "img/Y2.2d0f8d52.png";